module.exports = {"210303002":"繁荣街道","210303003":"八家子街道","210303005":"共和街道","210303006":"永乐街道","210303008":"南华街道","210303009":"大陆街道","210303012":"永发街道","210303013":"宁远街道","210303014":"达道湾街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210303.json
// module id = 614
// module chunks = 0